import { Component, ViewEncapsulation } from '@angular/core';
import { UIBlockingService } from "../core/ui-blocking.service";
import { ToastNotificationService } from "../core/toast-notification.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";
import { MemberAdService } from "./member-ad.service";
import { MemberAd } from "./DTOs/member-ad";
import { CommonLibrary } from "../core/common-library";
import { AdUploadResult } from "./DTOs/file-upload-result";
import { AdUpdateRequest } from "./DTOs/ad-update-request";
import { VerifyRejectRequest } from "../core/verify-reject-request";
import { EditAdModalComponent } from './Modals/edit-ad-modal.component';

@Component({
    selector: 'app-pending-ad-details',
    templateUrl: './pending-ad-details.component.html',
    encapsulation: ViewEncapsulation.None,
    providers: [UIBlockingService]

})
export class PendingAdDetailsComponent {
    constructor(private pendingAdService: MemberAdService
        , private blockUI: UIBlockingService
        , private notificationService: ToastNotificationService
        , private modalService: NgbModal
        , private route: ActivatedRoute
        , private router: Router) { }

    ad: MemberAd;

    ngOnInit() {
        this.refreshAd()
    }

    refreshAd() {
        this.ad = new MemberAd();
        this.route.params.subscribe(params => {
            const adId = +params['id'];
            this.getPendingAd(adId);
        });
    }

    getPendingAd(adId: number) {
        this.blockUI.start();
        this.pendingAdService.getPendingAd(adId).subscribe({
            next: (data) => {
                this.ad = data;
            },
            error: (err) => {
                this.notificationService.error(err.error.message);
                this.blockUI.stop();
                console.log(err)
            },
            complete: () => {
                this.blockUI.stop();
            }
        });
    }

    UpdateStatus(status: number) {
        const req = new VerifyRejectRequest(this.ad.adId.toString(), this.ad.approverNotes);
        this.pendingAdService.changeAdStatus(req, status).subscribe({
            next: (data) => {
            },
            error: (err) => {
                this.blockUI.stop();
                this.notificationService.error(err.error.message);
                console.log(err)
            },
            complete: () => {
                this.blockUI.stop();
                this.router.navigate(['/admin-portal/chamber/pending-ads/']);
            }
        });
    }

    openEditModal() {
        const modalRef = this.modalService.open(EditAdModalComponent, { size: 'md', backdrop: 'static' });
        modalRef.componentInstance.ad = this.ad;
        modalRef.result.then(response => {
            this.notificationService.success("Ad successfully updated.");
            this.refreshAd();
        })
            .catch(err => { });
    }

    protected readonly CommonLibrary = CommonLibrary;
}
